import type { ReportDataTableColumn } from '../../components/ReportDataTable'
import type { ConfiguredReportReportRow } from '../../types/pages'
import { display, makeLink } from '../../utils/configuredReportFormatters'

export const expireDefaultsColumns: ReportDataTableColumn<ConfiguredReportReportRow, string>[] = [
  {
    id: 'fk_applicant_id',
    label: 'Applicant',
    sortKey: 'fk_applicant_id',
    render: (row) =>
      row.fk_applicant_id && row.fk_user_id
        ? makeLink(
            `/defaults/default-detail/${row.fk_applicant_id}/${row.fk_user_id}`,
            display(row.fk_applicant_id),
            true,
          )
        : display(row.fk_applicant_id),
  },
  {
    id: 'name',
    label: 'Resident',
    sortKey: 'first_name',
    render: (row) =>
      `${display(row.first_name)} ${display(row.last_name)}`
        .replace(/—/g, '')
        .trim() || '—',
  },
  {
    id: 'property_name',
    label: 'Property',
    sortKey: 'property_name',
    render: (row) => display(row.property_name),
  },
  {
    id: 'rental_status',
    label: 'Rental Status',
    sortKey: 'rental_status',
    render: (row) => display(row.rental_status),
  },
  {
    id: 'document_status',
    label: 'Document Status',
    sortKey: 'document_status',
    render: (row) => display(row.document_status),
  },
  {
    id: 'lock_status',
    label: 'Lock Status',
    sortKey: 'lock_status',
    render: (row) => display(row.lock_status),
  },
  {
    id: 'expire_date',
    label: 'Action Date',
    sortKey: 'expire_date',
    render: (row) => display(row.expire_date),
  },
]
